module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Unlock-6b594a218b448b44defe30742a2875b9.svg";